export const noses: Array<string> = [
  require("./Nose_1.svg").default,
  require("./Nose_2.svg").default,
  require("./Nose_3.svg").default,
  require("./Nose_4.svg").default,
  require("./Nose_5.svg").default,
  require("./Nose_6.svg").default,
];
